import { FormRules } from '../utils/form'
import { i18n } from '../lang'

/* ---------- SEARCH ---------- */
export const searchListColumns = [
  { type: 'id', custom: { minWidth: 80 } },
  { type: 'name', custom: { minWidth: 160 } },
  { type: 'brand_name', custom: { minWidth: 140 } },
  { type: 'store_name', custom: { minWidth: 120 } },
  { type: 'store_type', custom: { minWidth: 120 } },
  { type: 'main_image', custom: { minWidth: 140 } },
  { type: 'currency', custom: { minWidth: 76 } },
  { type: 'list_price', custom: { minWidth: 80 } },
  { type: 'sale_price', custom: { minWidth: 80 } },
  { type: 'discount_rate', custom: { minWidth: 100 } },
  { type: 'in_stock', custom: { minWidth: 72 } },
  { type: 'liked', custom: { minWidth: 60 } },
  { type: 'product_type', custom: { minWidth: 98 } },
  { type: 'brand_link', custom: { minWidth: 100 } },
  { type: 'store_link', custom: { minWidth: 100 } },
  { type: 'shop_link', custom: { minWidth: 100 } },
  { type: 'similar_link', custom: { minWidth: 100 } },
  { type: 'product_link', custom: { minWidth: 100 } },
  { type: 'sku', custom: { minWidth: 100 } },
]
/* ---------- SEARCH ---------- */


/* ---------- HARDCODE PRODUCTS ---------- */
const ID_WIDTH = 78
export const hardcodeLists = {
  productPrice: {
    id: 'productPrice',
    label: i18n.t('hardcode.overrideProductPrice'),
    columns: [
      { type: 'id', custom: { width: ID_WIDTH } },
      { type: 'target_id', title: i18n.t('table.product_ids'), custom: { minWidth: 96 } },
      { type: 'currency', custom: { width: 72 } },
      { type: 'price', title: i18n.t('table.list_price'), custom: { width: 76 } },
      { type: 'discounted_price', title: i18n.t('table.sale_price'), custom: { width: 76 } },
      { type: 'special_usd_price', title: i18n.t('table.list_price_usd'), custom: { minWidth: 60 } },
      { type: 'special_usd_discounted_price', title: i18n.t('table.sale_price_usd'), custom: { minWidth: 60 } },
      { type: 'location', title: i18n.t('table.locations') },
    ],
  },
  storePrice: {
    id: 'storePrice',
    label: i18n.t('hardcode.overrideStorePrices'),
    columns: [
      { type: 'id', custom: { width: ID_WIDTH } },
      { type: 'store_id', title: i18n.t('table.storeId'), custom: { width: 100 } },
      { type: 'discount_rate', custom: { width: 100 } },
      { type: 'location', title: i18n.t('table.locations') },
    ],
  },
  forceOnline: {
    id: 'forceOnline',
    label: i18n.t('hardcode.forceOnline'),
    columns: [
      { type: 'id', custom: { width: ID_WIDTH } },
      { type: 'target_id', title: i18n.t('table.product_ids') },
    ],
  },
}

export const hardcodeFormRules = {
  idList: [FormRules.idList, FormRules.required],
  id: [FormRules.id, FormRules.required],
  required: [FormRules.required],
  requiredChange: [FormRules.requiredChange],
  requiredImageUrl: [FormRules.imageUrl, FormRules.required],
  countryList: [FormRules.countryList],
}

export const hardcodeForms = {
  productPrice: {
    refId: 'productPrice',
    type: 1,
    label: i18n.t('hardcode.overrideProductPrice'),
    template: [
      {
        key: 'target_id',
        isInput: true,
        title: i18n.t('table.product_ids'),
        rules: hardcodeFormRules.idList,
        custom: {
          placeholder: 'e.g. 10112,40564,64644',
        },
      },
      {
        key: 'currency',
        isSlot: true,
        rules: hardcodeFormRules.requiredChange,
      },
      {
        key: 'price',
        isInput: true,
        rules: hardcodeFormRules.required,
        title: i18n.t('table.list_price'),
      },
      {
        key: 'discounted_price',
        isInput: true,
        rules: hardcodeFormRules.required,
        title: i18n.t('table.sale_price'),
      },
      {
        key: 'special_usd_price',
        isInput: true,
        title: i18n.t('table.list_price_usd'),
      },
      {
        key: 'special_usd_discounted_price',
        isInput: true,
        title: i18n.t('table.sale_price_usd'),
      },
      {
        key: 'location',
        isInput: true,
        rules: hardcodeFormRules.countryList,
        title: i18n.t('table.locations'),
        custom: {
          placeholder: 'e.g. hk,us',
        },
      },
    ],
  },
  storePrice: {
    refId: 'storePrice',
    type: 2,
    label: i18n.t('hardcode.overrideStorePrices'),
    template: [
      {
        key: 'store_id',
        isSlot: true,
        rules: hardcodeFormRules.requiredChange,
      },
      {
        key: 'discount_rate',
        isInput: true,
        rules: hardcodeFormRules.required,
        custom: {
          placeholder: 'e.g. 0.8',
        },
      },
      {
        key: 'location',
        isInput: true,
        rules: hardcodeFormRules.countryList,
        title: i18n.t('table.locations'),
        custom: {
          placeholder: 'e.g. hk,us',
        },
      },
    ],
  },
  forceOnline: {
    refId: 'forceOnline',
    type: 4,
    label: i18n.t('hardcode.forceOnline'),
    template: [
      {
        key: 'target_id',
        isInput: true,
        title: i18n.t('table.product_ids'),
        rules: hardcodeFormRules.idList,
        custom: {
          placeholder: 'e.g. 10112,40564,64644',
        },
      },
    ],
  },
  newProduct: {
    refId: 'newProduct',
    type: 999,
    label: i18n.t('hardcode.newProduct'),
    template: [
      {
        key: 'categories',
        isSlot: true,
        rules: hardcodeFormRules.requiredChange,
      },
      {
        key: 'store_id',
        isSlot: true,
        rules: hardcodeFormRules.requiredChange,
      },
      {
        key: 'brand',
        isSlot: true,
        rules: hardcodeFormRules.requiredChange,
      },
      {
        key: 'sku',
        isInput: true,
        rules: hardcodeFormRules.required,
        title: i18n.t('table.sku'),
      },
      {
        key: 'product_name',
        isInput: true,
        rules: hardcodeFormRules.required,
        title: i18n.t('table.product_name'),
      },
      {
        key: 'description',
        isInput: true,
        custom: { type: 'textarea' },
        rules: hardcodeFormRules.required,
        title: i18n.t('table.description'),
      },
      {
        key: 'url',
        isInput: true,
        rules: [FormRules.url, FormRules.required],
        title: i18n.t('table.url'),
      },
      {
        key: 'imageurl',
        isInput: true,
        rules: hardcodeFormRules.required,
        trim: true,
        title: i18n.t('table.imageurl'),
      },
      {
        key: 'currency',
        isSlot: true,
        rules: hardcodeFormRules.requiredChange,
      },
      {
        key: 'list_price',
        isInput: true,
        rules: [FormRules.positiveNumber, FormRules.required],
        trim: true,
        title: i18n.t('table.list_price'),
      },
      {
        key: 'sale_price',
        isInput: true,
        rules: [FormRules.positiveNumber, FormRules.required],
        trim: true,
        title: i18n.t('table.sale_price'),
      },
      {
        key: 'list_price_usd',
        isInput: true,
        rules: [FormRules.positiveNumber],
        trim: true,
        title: i18n.t('table.list_price_usd'),
      },
      {
        key: 'sale_price_usd',
        isInput: true,
        rules: [FormRules.positiveNumber],
        trim: true,
        title: i18n.t('table.sale_price_usd'),
      },
      {
        key: 'status',
        isSwitch: true,
      },
    ],
  },
}

export const formDataMap = (formData) => {
  const newFormData = { ...formData }
  const { type } = newFormData
  if ('target_id' in newFormData) {
    if (type === 1 || type === 4) {
      newFormData.product_ids = newFormData.target_id
    }
    delete newFormData.target_id
  }
  const mapping = new Map([
    ['price', 'list_price'],
    ['discounted_price', 'sale_price'],
    ['special_usd_price', 'list_price_usd'],
    ['special_usd_discounted_price', 'sale_price_usd'],
  ])

  if ('discount_rate' in newFormData) {
    newFormData.discount_rate = Number(newFormData.discount_rate)
  }

  mapping.forEach((to, from) => {
    if (newFormData[from]) {
      newFormData[to] = newFormData[from]
      delete newFormData[from]
    }
  })
  return newFormData
}
/* ---------- HARDCODE PRODUCTS ---------- */

export const offlineProductTemplate = [
  {
    key: 'product_id',
    isInput: true,
    rules: hardcodeFormRules.id,
    trim: true,
  },
]
